import React from 'react';
import TopBar from './components/layout/TopBar/TopBar';
import Header from './components/layout/Header/Header';
import Nav from './components/layout/Navbar/Nav';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import LocalNews from './pages/LocalNews/LocalNews';
import WorldNews from './pages/WorldNews/WorldNews';
import Articles from './pages/Articles/Articles';
import Sports from './pages/Sports/Sports';
import Technology from './pages/Technology/Technology';
import Entertainment from './pages/Entertainment/Entertainment';
import Health from './pages/Health/Health';
import RefugeeIssues from './pages/RefugeeIssues/RefugeeIssues';
import Research from './pages/Research/Research';
import Footer from './components/layout/Footer/Footer';
import BreakingNewsBar from './components/cards/BreakingNewsBar'; 
import Events from './pages/Events/Events';
import Report from './pages/Report/Report';
import Economy from './pages/Economy/Economy';
import Live from './pages/Live/Live';
import NewsDetails from './components/cards/NewsDetails';
import Foo from './components/layout/Footer/Foo';
import ScrollToTop from './components/cards/ScrollToTop';
import SearchResults from './components/cards/SearchResults';


export default function App() {
  return (
    <div>
      <TopBar />
      <Header />
      <Nav />
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='localNews' element={<LocalNews />} />
        <Route path='worldNews' element={<WorldNews />} />
        <Route path='report' element={<Report />} />
        <Route path='articles' element={<Articles />} />
        <Route path='events' element={<Events />} />
        <Route path='sport' element={<Sports />} />
        <Route path='technology' element={<Technology />} />
        <Route path='entertainment' element={<Entertainment />} />
        <Route path='health' element={<Health />} />
        <Route path='refugeeIssues' element={<RefugeeIssues />} />
<Route path="/News/:category/:id/:slug" element={<NewsDetails />} />
<Route path="/search/:query" element={<SearchResults />} />
        <Route path='research' element={<Research />} />
        <Route path='economy' element={<Economy />} />
        <Route path='live' element={<Live />} />
      </Routes>
      <Footer />
      <Foo />
      <BreakingNewsBar /> 
    </div>
  );
}
